import _ from "lodash";
import { TokenData } from "../interfaces";

export const getUniqueTokenValues = (data: TokenData[]): TokenData[] =>
  _.uniqBy(
    data,
    ({ contractAddress, tokenId }) => `${contractAddress}_${tokenId}`,
  );

export const getURLParams = ({
  params,
  paramsToSkip = [],
}: {
  params: Record<string, any>;
  paramsToSkip?: string[];
}): URLSearchParams => {
  const requestParams = new URLSearchParams();

  Object.keys(params)
    .filter((param) => !paramsToSkip.includes(param))
    .forEach((param) => {
      const value = params[param];
      if (param === "sort")
        requestParams.append(
          `sort[${value.sortKey}]`,
          `${value.sortDirection}`,
        );
      else if (param === "tokens")
        getUniqueTokenValues(value as TokenData[]).forEach((token) => {
          requestParams.append(
            `tokens[${token.contractAddress}]`,
            token.tokenId.toString(),
          );
        });
      else if (Array.isArray(value))
        value.forEach((item: any) =>
          requestParams.append(param, item.toString()),
        );
      /**
       * An absent value is left out of the query string entirely.
       *
       * `URLSearchParams.append` stringifies whatever it is given, so an
       * unset filter went out as the literal `status=undefined`. To a
       * validating backend that is a value, not an absence — `@IsOptional()`
       * only skips `undefined` and `null` on the object, and by then the
       * string has already arrived. The DAO proposals list returned 400 on
       * every visit for exactly this: the page's default state is "no filter
       * selected", so the failure was total rather than occasional.
       *
       * Empty strings go the same way. A filter nobody set should not be in
       * the URL at all; a caller that genuinely means "empty" can send it
       * through `paramsToSkip` and build it by hand.
       */ else if (value !== undefined && value !== null && value !== "")
        requestParams.append(param, value);
    });

  return requestParams;
};
